import { NbDialogService } from '@nebular/theme';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Configuration } from 'app/models/configuration/configuration';
import { SiteSettings } from 'app/pages/settings/settings-page/site-settings';
import { ConfigurationService } from 'app/services/configurations/configurations.service';
import { DialogForgotPasswordComponent } from './dialog-forgot-password/dialog-forgot-password.component';
import { AuthService } from '../auth.service';

@Component({
  selector: 'ultra-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent  {

  userId: string;
  password: string;
  wrongLogin: boolean;
  needDocument: boolean;
  logoLogin: string = '';
  document: string;
  styleConfig = { backgroundColor: '#ffffff', };
  siteSettings = SiteSettings.getInstance();
  disabledButton: boolean = false;

  constructor(
    private authService: AuthService, 
    private httpClient: HttpClient, 
    private service: ConfigurationService,
    private dialogService: NbDialogService,
    ) {
    this._loadConfigServer();
    }

  _loadConfigServer(): void {
    this.service.getConfigurations().subscribe((value) => {
      this.siteSettings.setConfiguration(Configuration.fromJson(value.data));
      if (value.data != null) {
        this.loadConfigCustom();
      } else {
        this._loadConfigFile();
      }
    }, (error) => {
      console.log(`ERROR AO BUSCAR CONFIGURAÇÂO -> ${error.toJson}`)
      this._loadConfigFile();
    });
  }

  loadConfigCustom() {
    let config = this.siteSettings.getConfiguration();

    if (config != null && config != undefined) {
      if(config.src.length < 60){
        this._loadConfigFile();
      } else {
        this.styleConfig.backgroundColor = config.themeColor;
        this.logoLogin = config.src;
      }
    } else {
      this._loadConfigFile();
    }
  }

  _loadConfigFile(): void {
    this.httpClient.get('./assets/config.json').toPromise().then((data: any) => {
      const config: any = {
        baseUrl: data.base_url,
        CNPJ: data.CNPJ,
        srcLogin: data.src_login,
      };
      localStorage.setItem('config', JSON.stringify(config));
      this.logoLogin = data.src_login;
    });
  }

 
  login() {
    this.setMask();
    this.disabledButton = true;
    this.authService.getAccessToken(this.document, this.password).then(() => {
      this.wrongLogin = this.authService.isLoggedIn();
    }).finally(() => this.disabledButton = false);

  }

  setMask() {
    if (this.userId == null) return;

    if (this.userId?.length == 11) {
      this.document = this.userId.substring(0, 3) + '.' + this.userId.substring(3, 6) + '.'
        + this.userId.substring(6, 9) + '-' + this.userId.substring(9, 11);
    } else if (this.userId?.length == 14) {
      this.document = this.userId.substring(0, 2) + '.' + this.userId.substring(2, 5) + '.'
        + this.userId.substring(5, 8) + '/' + this.userId.substring(8, 12)
        + '-' + this.userId.substring(12, 14);
    }
  }

  keyPressNumbers(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  forgotPassword(userId: string){
    if(userId != '' && userId != undefined){
      this.dialogService.open(DialogForgotPasswordComponent, {
        context: {
          userId: userId,
        },
        closeOnBackdropClick: false,
        closeOnEsc: false,
      })
    }
    else
      this.needDocument = true
  }

  keyDownEvent(event) {
    if (event.keyCode === 13) {
      this.login();
    }
  }


}
